import { render, staticRenderFns } from "./profile.vue?vue&type=template&id=6b95ba85&scoped=true&"
import script from "./profile.vue?vue&type=script&lang=js&"
export * from "./profile.vue?vue&type=script&lang=js&"
import style0 from "./profile.vue?vue&type=style&index=0&id=6b95ba85&prod&lang=scss&module=true&"
import style1 from "./profile.vue?vue&type=style&index=1&id=6b95ba85&prod&lang=scss&scoped=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "6b95ba85",
  null
  
)

export default component.exports